import { ImportStatus } from './types'

export { ImportHistoryActions } from './actions'
export { importHistoryReducer } from './reducer'
export * from './types'
export { importHistorySagas } from './sagas'
export * from './selectors'

export const defaultStatusFilters: ImportStatus[] = [
  'Validated',
  'SearchInProgress',
  'SearchCompleted',
  'SearchError',
  'CheckProductsInProgress',
  'CheckProductsCompleted',
  'CheckProductsError',
  'CartInProgress',
  'CartCreated',
  'CartError',
  'OrderPlaced'
]

export const mapStatusToUserValue = (status: ImportStatus) => {
  switch (status) {
    case 'Validated':
    case 'SearchInProgress':
      return 'VALIDATE'
    case 'SearchCompleted':
    case 'SearchError':
    case 'CheckProductsInProgress':
      return 'SEARCH'
    case 'CheckProductsCompleted':
    case 'CheckProductsError':
    case 'CartInProgress':
      return 'CHECK PRODUCTS'
    case 'CartCreated':
    case 'CartError':
      return 'CART'
    case 'OrderPlaced':
      return 'ORDER PLACED'
    default:
      return status
  }
}

export const mapUserStatusToValue = (status: string): ImportStatus[] => {
  switch (status) {
    case 'VALIDATE':
      return ['Validated', 'SearchInProgress']
    case 'SEARCH':
      return ['SearchCompleted', 'SearchError', 'CheckProductsInProgress']
    case 'CHECK PRODUCTS':
      return ['CheckProductsCompleted', 'CheckProductsError', 'CartInProgress']
    case 'CART':
      return ['CartCreated', 'CartError']
    case 'ORDER PLACED':
      return ['OrderPlaced']
    default:
      return []
  }
}
